module.exports = __webpack_public_path__ + "static/media/grains_4.133b2401.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/grains/grains_4.csv
// module id = 732
// module chunks = 0